Ext.define('SA.view.PackageDataRemovedPopup', {
    alias: 'widget.package-data-removed-popup',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-package-data-removed-popup',
    includeOkBtn: true,
    title: 'Data Variables Removed',

    getBodyItems() {
        var institutionName = SA.Institution.getName(),
            packageNames = this.notice.getPackageNames().sort(),
            messageText = this.getMessageText(institutionName, packageNames);

        return {
            xtype: 'component',
            cls: 'sa-package-data-removed-popup-message',

            html: [
                '<svg class="sa-package-data-removed-popup-message-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div class="sa-package-data-removed-popup-message-text">',
                    messageText,
                '</div>'
            ]
        };
    },

    getMessageText(institutionName, packageNames) {
        packageNames = packageNames.map(wrapWithStrong);

        var tpl = new Ext.XTemplate(
                '<strong>{institutionName}</strong> no longer subscribes to the {packageNames:commaList("or", "data package")}. ',
                'As a result, these data variables have been removed from your account.',
                '<br><br>',
                'If you have any questions, please contact ',
                '<a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a>.'
            );

        return tpl.apply({institutionName, packageNames});

        function wrapWithStrong(name) {
            return '<strong>' + name + '</strong>';
        }
    },

    onDestroy() {
        this.notice.markViewed();

        this.callParent();
    }
});
